import { useState } from 'react';
import { Button, InnerPageToggleButton } from '@wajeez-web/components/ui';
import { identityClient, Server } from '@wajeez-web/core/api-base';
import {
  useBusinessSelector,
} from '@wajeez-web/stores/business-group';

const BusinessReports = ({ id, title }: { id: number; title: string }) => {
  const [loading, setLoading] = useState(false);
  const { detailsMultilingual } =
    useBusinessSelector((state) => state.businessGroups);

  const downloadMonthlyReportAsCsv = async () => {
    setLoading(true);
    try {
      const data = await GetBusinessGroupMonthlyReport({ businessGroupId: id });

      downloadAsCsv(data, `${detailsMultilingual.data?.prefix} - Monthly Report - ${new Date().toLocaleDateString()}`);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  }

  const downloadSkillCompletionReportAsCsv = async () => {
    setLoading(true);   
     try {
      const data = await GetBusinessGroupSkillCompletionReport({ businessGroupId: id });

      downloadAsCsv(data, `${detailsMultilingual.data?.prefix} - Skill Completion Report - ${new Date().toLocaleDateString()}`);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-primary"></div>
      </div>
    )
  }

  return (
    <>
      <div className="space-y-6">
        <div className="flex justify-between">
          <div>
            <h3 className="ms-2 lg:ms-0 text-2xl flex align-middle font-bold space-s-2 tracking-tight leading-none  ">
              {<InnerPageToggleButton />} <div className="mt-1">{title}</div>
            </h3>
            <p className=" text-sm text-gray-600"></p>
          </div>

        </div>
        <div className="flex justify-start flex-col gap-y-2">
          <Button
            color="white"
            title="Monthly Report"
            bg="primary"
            onClick={downloadMonthlyReportAsCsv}
          />
          <Button
            color="white"
            title="Skill Completion Report"
            bg="primary"
            onClick={downloadSkillCompletionReportAsCsv}
          />
        </div>
      </div>

    </>
  );
};

export default BusinessReports;


export async function GetBusinessGroupMonthlyReport({
  businessGroupId }: { businessGroupId: number }): Promise<Server.BusinessGroupMonthlyReport[]> {
  const client = new Server.Server_BusinessGroup_Client(undefined, identityClient);
  const response = await client.admin_BusinessGroup_monthlyReport_get_V1(businessGroupId);

  if (response.success && response.data) {
    return response.data;
  }

  return [];
}


export async function GetBusinessGroupSkillCompletionReport({
  businessGroupId }: { businessGroupId: number }): Promise<Server.BusinessGroupSkillCompletionReport[]> {
  const client = new Server.Server_BusinessGroup_Client(undefined, identityClient);
  const response = await client.admin_BusinessGroup_skillCompletionReport_get_V1(businessGroupId);

  if (response.success && response.data) {
    return response.data;
  }

  return [];
}


// download the object array as csv with headers and support for utf-8 characters
export function downloadAsCsv<T extends object>(data: T[], fileName: string) {
  if (!data.length) {
    return;
  }
  const headers = Object.keys(data[0]) as (keyof T)[];
  const csv = [
    headers.join(','),
    ...data.map((row) =>
      headers.map((fieldName) => {
        const field = row[fieldName];
        if (typeof field === 'string') {
          return `"${(field as string).replace?.(/"/g, '""')}"`;
        }
        return field;
      }).join(',')
    ),
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${fileName}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}